function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M2.54861 5.63357l0 -1.01528 0.696154 0 0 0.171854 -0.490972 0 0 0.240169 0.423839 0 0 0.171854 -0.423839 0 0 0.431406 -0.205181 0zm1.70245 0l-0.22315 0 -0.0886417 -0.230713 -0.405878 0 -0.0836811 0.230713 -0.217476 0 0.395476 -1.01528 0.216768 0 0.406583 1.01528zm-0.377508 -0.401622l-0.139941 -0.376799 -0.137106 0.376799 0.277047 0zm1.13584 0.0283661l0.198559 0.062878c-0.0304921,0.110866 -0.0810787,0.19313 -0.151992,0.247028 -0.0706772,0.0536575 -0.160744,0.0806063 -0.269717,0.0806063 -0.13474,0 -0.245606,-0.0460945 -0.332362,-0.138051 -0.086752,-0.092189 -0.130248,-0.218185 -0.130248,-0.377744 0,-0.16902 0.0437323,-0.300213 0.130957,-0.393823 0.0872283,-0.093374 0.201878,-0.140177 0.344181,-0.140177 0.124102,0 0.225039,0.0366417 0.302575,0.110157 0.0463307,0.0432598 0.0808425,0.105665 0.104008,0.18698l-0.203051 0.0484606c-0.0118228,-0.0527126 -0.036878,-0.0943189 -0.0751732,-0.124811 -0.0380591,-0.0304961 -0.0843898,-0.045626 -0.13876,-0.045626 -0.0751693,0 -0.136394,0.0269488 -0.183201,0.0810827 -0.0468031,0.0538976 -0.0702047,0.141358 -0.0702047,0.26239 0,0.128358 0.0229291,0.219839 0.0692598,0.274209 0.0460984,0.0546063 0.106138,0.0817913 0.17989,0.0817913 0.0546063,0 0.101413,-0.0172559 0.140654,-0.0520079 0.0392402,-0.0345118 0.0673701,-0.0891181 0.084626,-0.163343zm0.603016 0.373256l0 -0.843429 -0.301157 0 0 -0.171854 0.806791 0 0 0.171854 -0.300449 0 0 0.843429 -0.205185 0z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "fil0",
  d: "M2.40683 4.06374c0,0.0441811 0.0358189,0.08 0.08,0.08 0.0441811,0 0.08,-0.0358189 0.08,-0.08l0 -2.25041 2.80151 0 0.731484 0.731484 0 1.51893c0,0.0441811 0.0358189,0.08 0.08,0.08 0.0441811,0 0.08,-0.0358189 0.08,-0.08l0 -1.55205 -3.93701e-006 0c0,-0.0204724 -0.00780709,-0.0409488 -0.0234291,-0.0565669l-3.93701e-006 3.93701e-006 -0.77802 -0.77802c-0.0145039,-0.0146772 -0.0346378,-0.0237756 -0.0569016,-0.0237756l-2.91464 0c-0.0441811,0 -0.08,0.0358189 -0.08,0.08l0 2.33041zm3.853 2.12438c0,-0.0441811 -0.0358189,-0.08 -0.08,-0.08 -0.0441811,0 -0.08,0.0358189 -0.08,0.08l0 0.665213 -3.533 0 0 -0.665213c0,-0.0441811 -0.0358189,-0.08 -0.08,-0.08 -0.0441811,0 -0.08,0.0358189 -0.08,0.08l0 0.745213c0,0.0441811 0.0358189,0.08 0.08,0.08l3.693 0c0.0441811,0 0.08,-0.0358189 0.08,-0.08l0 -0.745213z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "fil0",
  d: "M5.48147 1.73333c0,-0.0441811 -0.0358189,-0.08 -0.08,-0.08 -0.0441811,0 -0.08,0.0358189 -0.08,0.08l0 0.389177c0,0.129106 0.0527638,0.246421 0.137756,0.331417 0.0849961,0.0849921 0.202311,0.137756 0.331417,0.137756l0.389177 0c0.0441811,0 0.08,-0.0358189 0.08,-0.08 0,-0.0441811 -0.0358189,-0.08 -0.08,-0.08l-0.389177 0c-0.084937,0 -0.162217,-0.034811 -0.218291,-0.0908819 -0.0560709,-0.0560748 -0.0908819,-0.133354 -0.0908819,-0.218291l0 -0.389177z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "fil0",
  d: "M2.04518 6.10811l4.5763 0 0 -1.96438 -4.5763 0 0 1.96438zm4.6563 0.16l-4.7363 0c-0.0441811,0 -0.08,-0.0358189 -0.08,-0.08l0 -2.12438c0,-0.0441811 0.0358189,-0.08 0.08,-0.08l4.7363 0c0.0441811,0 0.08,0.0358189 0.08,0.08l0 2.12438c0,0.0441811 -0.0358189,0.08 -0.08,0.08z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "fil0",
  d: "M3.11986 2.5703c-0.0441811,0 -0.08,0.0358189 -0.08,0.08 0,0.0441811 0.0358189,0.08 0.08,0.08l1.72368 0c0.0441811,0 0.08,-0.0358189 0.08,-0.08 0,-0.0441811 -0.0358189,-0.08 -0.08,-0.08l-1.72368 0z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "fil0",
  d: "M3.11986 3.01156c-0.0441811,0 -0.08,0.0358189 -0.08,0.08 0,0.0441811 0.0358189,0.08 0.08,0.08l2.42694 0c0.0441811,0 0.08,-0.0358189 0.08,-0.08 0,-0.0441811 -0.0358189,-0.08 -0.08,-0.08l-2.42694 0z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "fil0",
  d: "M3.11986 3.45282c-0.0441811,0 -0.08,0.0358189 -0.08,0.08 0,0.0441811 0.0358189,0.08 0.08,0.08l2.42694 0c0.0441811,0 0.08,-0.0358189 0.08,-0.08 0,-0.0441811 -0.0358189,-0.08 -0.08,-0.08l-2.42694 0z"
});

var SvgFact = function SvgFact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 8.66666 10.833325",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fact.9ef40c43.svg";
export { ForwardRef as ReactComponent };